import axios, {CancelTokenSource} from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {AXIOS_CANCEL_MSG, AssemblyDocument} from '../api/models';
import { ConfiguratorContext } from '../context';

interface QuoteAssemblyDocumentsProps {
  quoteId: string | undefined
  revisionId?: number
}

export const useQuoteAssemblyDocuments = (props: QuoteAssemblyDocumentsProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:QuoteAssemblyDocumentsProps  ) : Promise<AssemblyDocument[] | undefined> => {

    if ( !props.quoteId) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchQuoteAssemblyDocuments( props.quoteId, props.revisionId, cancelSource.token );
      cancelTokenSourceRef.current = undefined;
      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  return useSWR([
    'fetchQuoteAssemblyDocuments',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      revalidateOnFocus: false,
      dedupingInterval:1
    }
  );
};


export default useQuoteAssemblyDocuments;
